import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  CommonErrorMsg,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";

import { toast } from "react-toastify";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { KendoLoader } from "../../Kendo/kendo_loader";
import {
  corefetch,
  CorebaseURL,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";

const Payment_Methods = () => {
  const modalRef = useRef(null);
  const ItemmodalRef = useRef(null);
  const [editVisible, setEditVisible] = useState(false);
  const [Dup, setDup] = useState(false);
  const [ItemDup, setItemDup] = useState(false);
  const [OverSize, setOverSize] = useState(false);
  const [error, setError] = useState({});
  const [Loading, setLoading] = useState(false);
  const [CategoryList, setCategoryList] = useState([]);
  const [ItemList, setItemList] = useState([]);
  const [refreshflag, setrefreshflag] = useState(0);
  const [imageList, setImageList] = useState([]);
  const [selectedImageID, setSelectedImageID] = useState(null);
  const imageListRef = useRef(imageList);
  const [dragging, setDragging] = useState(null);
  const [removedImageIds, setRemovedImageIds] = useState();
  const [ytLink, setytLink] = useState(false);
  const [image, setImage] = useState(null);

  const [PaymentMethods, setPaymentMethods] = useState({
    PaymentMethodID: 0,
    PaymentMethod: "",
    PaymentMethodLink: "",
    SampleImage: "",
    PaymentAddress: "",
    AccountNumber: "",
    WireRoutingNo: "",
    BankName: "",
    SampleImageName: "",
    Image: "",
  });

  const [Item, setItem] = useState({
    CategoryID: 0,
    ItemID: 0,
    ItemName: "",
    Rate: "",
    StartRate: "",
    EndRate: "",
    Quantity: "",
    YoutubeLink: "",
    Description: "",
    ImagesModel: [],
    Images: [],
    OldimagePath: [],
    ImageSortOrder: 0,
  });

  const handleToggleClick = async (id, newStatus) => {
    await corefetch(
      `Rental/UpdateRCategoryPoular?CategoryID=${id}&Ispopular=${newStatus}&ModifiedBy=${sessionUser()}`,
      true,
      false,
      false,
      true
    );
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (event.target.classList.contains("status-toggle")) {
        const id = event.target.getAttribute("data-id");
        const newStatus = event.target.checked ? true : false;
        handleToggleClick(id, newStatus);
      }
    };
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    // Check if file is provided. If not, simply clear any previous file.
    if (!file) {
      setOverSize(false);
      setPaymentMethods((prev) => ({
        ...prev,
        Image: "", // Clear the file if nothing selected
      }));
      // Optionally, you can trigger onValidation for other fields if needed.
      return;
    }

    // Validate file type (only allow JPEG and PNG)
    const isValidType = file.type === "image/png" || file.type === "image/jpeg";
    if (!isValidType) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      setOverSize(false);
      setPaymentMethods((prev) => ({
        ...prev,
        Image: "",
      }));
      return;
    }

    // Validate file size (max 500KB)
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    const isFileTooLarge = file.size > maxSizeInBytes;
    setOverSize(isFileTooLarge);

    // If file is valid and not too large, update the state with the file
    if (!isFileTooLarge) {
      setPaymentMethods((prev) => ({
        ...prev,
        Image: file, // Save file to state for FormData submission
      }));
    } else {
      // If file is too large, clear the file
      setPaymentMethods((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  //   const handleFileChange = (e) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       // Set the Image file
  //       setPaymentMethods({
  //         ...PaymentMethods,
  //         Image: file,
  //         SampleImage: file.name, // Set the file name as SampleImage
  //       });
  //     }
  //   };
  const fetchData = async () => {
    try {
      const list = await corefetch("Decoration/GetDecorationItemDetails");
      setItemList(list);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const onParentEditClick = async (e) => {
    let temp = PaymentMethods;
    PaymentMethods.PaymentMethodID = e.paymentMethodID;
    PaymentMethods.PaymentMethod = e.paymentMethod;
    PaymentMethods.PaymentMethodLink = e.paymentMethodLink;
    PaymentMethods.SampleImage = e.sampleImage;
    PaymentMethods.BankName = e.bankName;
    PaymentMethods.AccountNumber = e.accountNumber;
    PaymentMethods.WireRoutingNo = e.wireRoutingNo;
    PaymentMethods.PaymentAddress = e.paymentAddress;

    setPaymentMethods(temp);
    setEditVisible(true);

    const modal = new bootstrap.Modal(document.getElementById("add_Item"));
    modal.show();
  };

  const onItemSubmit = async (e) => {
    e.preventDefault();
    const err = ValidateForm(e);
    if (err && !OverSize) {
      setError(err);
    } else if (!OverSize) {
      const formData = new FormData();
      formData.append("PaymentMethodID", PaymentMethods.PaymentMethodID);
      formData.append("PaymentMethodLink", PaymentMethods.PaymentMethodLink);
      formData.append("AccountNumber", PaymentMethods.AccountNumber);
      formData.append("BankName", PaymentMethods.BankName);
      formData.append("WireRoutingNo", PaymentMethods.WireRoutingNo);
      formData.append("PaymentAddress", PaymentMethods.PaymentAddress);
      formData.append("SavedBy", sessionUser());
      formData.append("SampleImage", PaymentMethods.SampleImage);
      if (PaymentMethods.Image) {
        formData.append("Image", PaymentMethods.Image);
      }
      formData.append("SampleImageName", PaymentMethods.SampleImageName || "");
      setLoading(true);
      try {
        await corepost(
          "PaymentMethod/InsertUpdateDecorationCategory",
          formData,
          true,
          true,
          false,
          false
        );
        setLoading(false);
        setrefreshflag(refreshflag + 1);
        fetchData();
        clearItemForm();
        $("#Category-cancel").click();
      } catch (error) {
        console.error("Error while submitting the form:", error);
        setLoading(false);
      }
    }
  };

  const clearItemForm = () => {
    setLoading(false);
    $("#hide").click();
    setPaymentMethods({
      PaymentMethodID: 0,
      PaymentMethod: "",
      PaymentMethodLink: "",
      SampleImage: "",
      PaymentAddress: "",
      AccountNumber: "",
      WireRoutingNo: "",
      BankName: "",
      SampleImageName: "",
      Image: "",
    });
    // setImage("");
    setImageList([]);
    setError({});
    setDup(false);
    setEditVisible(false);

    const form = document.getElementById("form-item-config");
    if (form) {
      form.reset();
    }
    setSelectedImageID(0);
  };

  const onRowReorderChange = async (List) => {
    let ID = $(List.newRow).find("td").eq(0).text();
    let oldSortId = $(List.newRow).find("td").eq(1).text();
    let newSortId = $(List.oldRow).find("td").eq(1).text();
    await corefetch(
      `PaymentMethod/SortPaymentMethod?TypeId=${ID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
    );
    setrefreshflag(refreshflag + 1);
  };
  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Payment Methods</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <li>Configuration</li>
              </li>
              <li className="breadcrumb-item active">Payment Methods</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto"></div>
            </div>

            <div>
              <KendoGrid
                name={"RentalItem"}
                url={CorebaseURL + "PaymentMethod/GetPaymentMethods"}
                // url={`${CorebaseURL}/Rental/GetRentalItemDetails?itemId=${itemID}`}
                schema={{}}
                columns={[
                  {
                    field: "paymentMethodID",
                    filterable: false,
                    hidden: true,
                  },
                  { field: "orderBy", hidden: true },

                  {
                    field: "paymentMethod",
                    title: "Payment Method Names",
                    width: 150,
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={false}
                onEditClick={(e) => onParentEditClick(e)}
                paggable={true}
                disableExportExcel={true}
                height={"60vh"}
                refreshWhen={refreshflag}
                // enableRowReorderable={true}
                // onRowReorder={onRowReorderChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade"
        id="add_Item"
        role="dialog"
        ref={ItemmodalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered RentalItem"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                id="close"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearItemForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-item-config" onSubmit={onItemSubmit}>
                <input
                  type="hidden"
                  name="ID"
                  value={PaymentMethods.PaymentMethodID || 0}
                />

                <div className="row">
                  <div className="col-6 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        {["Credit Card", "Debit Card"].includes(
                          PaymentMethods.PaymentMethod
                        )
                          ? "Payment Link"
                          : "Pay To"}
                        <span className="text-danger">*</span>
                      </label>
                      <textarea
                        type="text"
                        maxLength={500}
                        className="form-control field"
                        name="PaymentMethodLink"
                        value={PaymentMethods.PaymentMethodLink || ""}
                        placeholder={
                          ["Credit Card", "Debit Card"].includes(
                            PaymentMethods.PaymentMethod
                          )
                            ? "Payment Link"
                            : "Pay To"
                        }
                        data-required="true"
                        onChange={(e) => {
                          setPaymentMethods((prev) => ({
                            ...prev,
                            PaymentMethodLink: e.target.value,
                          }));
                          onValidation("PaymentMethodLink", e.target.value);
                        }}
                      />
                      {error.PaymentMethodLink && (
                        <ErrorMsg text="Payment Method is required." />
                      )}
                    </div>
                  </div>

                  <div className="col-4 mb-3">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        {" "}
                        Image
                        <InfoIcon
                          content="Ensure the image size does not exceed 500KB.;
                                   Please upload the image in JPEG, JPG or PNG format."
                        />
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={handleFileChange}
                      />
                      {/* {error.Image && <ErrorMsg text=" Image is required" />} */}
                      {error.ValidFile && (
                        <ErrorMsg text="please upload Image file only" />
                      )}
                      {OverSize && (
                        <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                      )}
                    </div>
                  </div>
                  <div className="col-2 mb-3">
                    {PaymentMethods.SampleImage &&
                      PaymentMethods.PaymentMethodID > 0 && (
                        <div
                          style={{
                            width: "100%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <img
                            src={PaymentMethods.SampleImage}
                            alt="Sample"
                            style={{ maxWidth: "100%", height: "400" }}
                          />
                        </div>
                      )}
                    {/* <input
                        type="hidden"
                        name="Image"
                        id="image-name"
                        data-required="true"
                        value={PaymentMethods.Image || ""}
                      /> */}
                    <input
                      type="hidden"
                      name="SampleImage"
                      value={PaymentMethods.SampleImage}
                    />
                  </div>
                </div>
                {PaymentMethods.PaymentMethod === "Wire Transfer" && (
                  <div className="row">
                    <div className="col-4 mb-3">
                      <div className="input-block">
                        <label className="form-label">
                          Bank Name<span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          maxLength={500}
                          className="form-control field"
                          name="BankName"
                          value={PaymentMethods.BankName || ""}
                          placeholder="BankName"
                          data-required="true"
                          onChange={(e) => {
                            setPaymentMethods((prev) => ({
                              ...prev,
                              BankName: e.target.value,
                            }));
                            onValidation("BankName", e.target.value);
                          }}
                        />
                        {error.BankName && (
                          <ErrorMsg text="Bank Name is required." />
                        )}
                      </div>
                    </div>
                    <div className="col-4 mb-3">
                      <div className="input-block">
                        <label className="form-label">
                          Account Number<span className="text-danger">*</span>
                          <InfoIcon content="Account Number should be at least 8 digits and no more than 34 digits." />
                        </label>
                        <textarea
                          type="text"
                          maxLength={34}
                          className="form-control field"
                          name="AccountNumber"
                          value={PaymentMethods.AccountNumber || ""}
                          placeholder="Account Number"
                          data-required="true"
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only digits
                            if (/^\d*$/.test(value)) {
                              setPaymentMethods((prev) => ({
                                ...prev,
                                AccountNumber: value,
                              }));
                              onValidation("AccountNumber", value);
                            }
                          }}
                        />
                        {error.AccountNumber && (
                          <ErrorMsg text="Account Number is required." />
                        )}
                      </div>
                    </div>
                    <div className="col-4 mb-3">
                      <div className="input-block">
                        <label className="form-label">
                          Wire Routing No<span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          maxLength={20}
                          className="form-control field"
                          name="WireRoutingNo"
                          value={PaymentMethods.WireRoutingNo || ""}
                          placeholder="Wire Routing No"
                          data-required="true"
                          onChange={(e) => {
                            const value = e.target.value;
                            // Only update if the value contains only digits
                            if (/^\d*$/.test(value)) {
                              setPaymentMethods((prev) => ({
                                ...prev,
                                WireRoutingNo: value,
                              }));
                              onValidation("WireRoutingNo", value);
                            }
                          }}
                        />
                        {error.WireRoutingNo && (
                          <ErrorMsg text="Wire Routing No is required." />
                        )}
                      </div>
                    </div>
                    <div className="col-4 mb-3">
                      <div className="input-block">
                        <label className="form-label">
                          Payment Address<span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          maxLength={50}
                          className="form-control field"
                          name="PaymentAddress"
                          value={PaymentMethods.PaymentAddress || ""}
                          placeholder="Payment Address"
                          data-required="true"
                          onChange={(e) => {
                            setPaymentMethods((prev) => ({
                              ...prev,
                              PaymentAddress: e.target.value,
                            }));
                            onValidation("PaymentAddress", e.target.value);
                          }}
                        />
                        {error.PaymentAddress && (
                          <ErrorMsg text="Payment Address is required." />
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="Category-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearItemForm();
                      }}
                    />
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearItemForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add Item Modal --> */}
    </>
  );
};

export default Payment_Methods;
